import React from 'react';

const delay = 200;

export const Dozvon: React.FC = () => {
    const [dots, setDots] = React.useState<number>(1);

    React.useEffect(() => {
        const interval = setInterval(() => setDots(dots => (dots + 1) % 3), delay);

        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{ fontSize: '1.2rem', fontFamily: 'Inter', textAlign: 'center' }}>Дозвон{'.'.repeat(1 + dots)}</div>
    );
};
